import { Component } from '@angular/core';
import { LoginButtonComponent } from '../../components/login-button/login-button.component';

@Component({
  imports: [LoginButtonComponent],
  selector: 'auth-login',
  templateUrl: 'login.page.html'
})

export class LoginPageComponent {

}
